import { Injectable } from '@angular/core';

//import { Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { concatMap, mergeMap, retry, tap, map, zip, catchError } from 'rxjs/operators';
import * as URLSearchParams from 'url-search-params';
import { CFHttpClient } from '@mem-shared/cf-http-client';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { UserSession } from '@mem-shared/user-session';
import { LOGIN_ERRORS } from './new-login-error-config';
import { getEAIConfig } from './new-login-eai-config';
import { MemberAuditService } from 'app/shared/audit/member-audit.service';

import { GoogleAnalyticsService } from 'app/core/google-analytics/google-analytics.service';

import { environment } from './../../environments/environment';

const loginUrl = environment.servicePublicURLs.loginURL; //'/EAI5/EAIProcessServlet';
const logoutUrl = environment.serviceSecuredURLs.logoutURL; //'/mas/sec/logout.json';

const siteKeyUrl = environment.servicePublicURLs.siteKeyURL; //'/mas/pub/getUserSiteKeyDetails.json';
const forgotUsernameUrl = environment.servicePublicURLs.forgotUsernameURL; //'/mas/pub/findRegisteredMember';
const questionsUrl = environment.servicePublicURLs.randomChallengesURL; //'/mas/pub/randomChallenges.json';
const ebizUrl = environment.servicePublicURLs.ebizURL; //`https://webapp.carefirst.com/secure/eBizAdmin/member-admin/users/MemberSearchDisplay.do`;


import { DocViewerService } from '@mem-shared/doc-viewer.service';

const formUrlEncodedHttpOptions = {
  headers: new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8'),
  params: new HttpParams().set('timeStamp', new Date().toISOString())
};

// const formUrlEncodedHttpOptions = {
//   headers: new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded')
// };

@Injectable()
export class NewLoginSeviceService {
  updateMemberCommunicationInfoUrl = environment.serviceSecuredURLs.updateMemberEmailOrPhoneInfoURL; //'/mas/sec/updateMemberEmailOrPhoneInfo.json';
  sendEmailSecurityTokenUrl = environment.servicePublicURLs.sendEmailSecurityTokenURL; //'/mas/pub/sendEmailSecurityToken.json'
  verifyEmailSecurityTokenUrl = environment.servicePublicURLs.verifyEmailSecurityTokenURL; // '/mas/pub/verifyEmailSecurityToken.json'
  sendMobilePhoneSecurityTokenUrl = environment.servicePublicURLs.sendMobilePhoneSecurityTokenURL //'/mas/pub/sendMobilePhoneSecurityToken.json',
  verifyMobilePhoneSecurityTokenUrl = environment.servicePublicURLs.verifyMobilePhoneSecurityTokenURL //'/mas/pub/verifyMobilePhoneSecurityToken.json'


  memberCriteria = {};
  enableMemberId: boolean;
  enableAlternateId: boolean;
  callNativeForTouchId:number = 0;

  touchIdEnabledUserId;
	faceIdEnabledUserId;
  touchIDshow = false; //Scope variable for toggling the Touch ID button display
	faceIDshow = false; //Scope variable for toggling the Face ID button display  
  incorrectPassword: boolean;
  constructor(
    private http: CFHttpClient,
    private ga: GoogleAnalyticsService,
    private userSession: UserSession,
    private router: Router,
    private auditService: MemberAuditService,
    private httpClient: HttpClient,
    private docViewer: DocViewerService,
  ) { }
/**
   * Attempt to log user in via EAI
   * @param credentials username and password
   */
  login(username = '', password) {
    //console.log("UserName1:::::"+username);
    //console.log("UserName1:::::"+password);

    const body = {
      ...getEAIConfig(),
      username: username,
      password: password
    };   
   // console.log(JSON.stringify(this.http.post(loginUrl, body, formUrlEncodedHttpOptions)));
    return this.http.post(loginUrl, body, formUrlEncodedHttpOptions).pipe(
      // Sometimes EAI fails and returns an empty response so we have
      // to perform a check. The check will throw an error if the
      // response is emtpy that will trigger the retry      
      map(this.isEaiEmpty),
      retry(1),
      map((res: any) => {
        // See if response code is in the errors array and throw
        // and error if so. This is neede since EAI returns a success
        // response but has an error
        if (Object.values(LOGIN_ERRORS).indexOf(res.responseCode) !== -1 && res.loginStatus === 'S900' ) {
          this.invokeMemberAudit(res, false);
          throw res;
        }
        
        this.invokeMemberAudit(res, true);
      
        return res;
      })
    );
  }

  /**
   * Logout the user
   */
  logout(accountId) {
    // need to make davis vision optional. current app does
    // it based on localstorage variable but we should just do
    // userSession session variable
    return this.davisVisionLogout().pipe(
      zip(
        this.logoutPCI(),
        this.logoutWebseal()
      ),
      catchError(err => {
        //console.log('PCI Logout Failed');
        //alert('PCI Logout Failed');
        return Observable.of(err);
      }),
      concatMap(() => this.logoutSBS(accountId)),
      retry(1));
  }

  private logoutPCI() {
    const logoutPCIUrl = 'https://' + this.getLogoutHost() + '/cms/ibm_security_logout';
    //console.log('logging out of PCI');
    //alert('logging out of PCI');
    return this.http.get(logoutPCIUrl, {}, { responseType: 'text' });
  }

  private logoutWebseal() {
    const logoutWebSealUrl = 'https://' + this.getLogoutHost() + '/pkmslogout';
    //console.log('logging out of Webseal');
    //alert('logging out of Webseal');
    return this.http.get(logoutWebSealUrl, {}, { responseType: 'text' });
    
  }

  private logoutSBS(accountId) {
    //console.log('logging out of SBS');
    //alert('logging out of SBS');
    return this.http.post(logoutUrl + `?accountId=${accountId}&timeStamp=${new Date().toISOString()}`);
    
  }

  private getLogoutHost() {
    if (!location.host.includes('sit')) {
      return 'card.carefirst.com';
    } else {
      return 'cardsitb.carefirst.com';
    }
  }

  private davisVisionLogout() {
    return this.http.get('/mas/sec/getDavisVisionSSOSignOutUrl.json').do((url) => console.log('returned from davis logout' + url)
  );
  }

  /**
   * Get the users sitekey details if valid user
   * @param username should not be empty, default it to empty string to avoid null checking
   */
  siteKey(username = '') {
    return this.http
      .get(siteKeyUrl, {
        userId: username.toUpperCase().trim(),
        fetchImage: 'separate'
      })
      .pipe(
        map(res => {
          // newly registred user will have null image so we need
          // to show not found scenario
          if (res.siteKey && !res.siteKey.imageId) {
            throw res;
          } else {
            return res;
          }
        })
      );
  }

  /**
   * Invoke Member Audit for Login
   */
  invokeMemberAudit(res, success) {
    let isSuccess: boolean;
    let errorCode;
    let infoDetails = '';
    let transactionTypeCode = '';
    //Added for touch / face id audit table changes 
    if(this.userSession.getLocalStorageItem('touchid') == "true"){
      infoDetails = 'Biometric Login';
      transactionTypeCode = 'M.02.005';
      this.trackGAEvent('Click:Login','Biometric Login'); 
    }else{
      infoDetails = 'Regular Login';
      transactionTypeCode = 'M.02.001';
    }
   
    if (success) {
      isSuccess = true;
      errorCode = '0000';
    } else if (!success) {
      isSuccess = false;
      errorCode = res.error;
    }

    this.auditService.audit(transactionTypeCode, isSuccess, errorCode, { info: infoDetails });
  }

  /**
   * Set Remember Me. Handels the remember me
   */
  setRememberMe(rememberMe, username) {  
    if (rememberMe) {
      this.userSession.setLocalStorageItem('rememberMe', username, { persist: true });
    } else {
      this.userSession.removeLocalStorageItem('rememberMe');
    }
  }

  /**
   * EAI Empty Response Check
   */
  private isEaiEmpty(res) {
 
    if (typeof res === 'undefined' || res === null || Object.keys(res).length === 0) {
      throw res;
    } else {
      return res;
    }
  }


  // Tracking the GA event
  trackGAEvent(action: string, event: string) {
    if (typeof this.ga.submitEventToGA === "function") {
      this.ga.submitEventToGA(action, event);
    }
  }

  updateMemberCommunicationInfo(urlParams, params) {
    const paramsForURL = new URLSearchParams();
    for (const key in urlParams) {
      if (urlParams.hasOwnProperty(key)) {
        paramsForURL.set(key, urlParams[key]);
      }
    }
    let tempParams = paramsForURL.toString();
    let url = this.http.getAbsoluteURL(this.updateMemberCommunicationInfoUrl) + '?' + tempParams
    // return this.http.post(this.updateMemberCommunicationInfoUrl, params);
   // return this.httpClient.post(this.http.getAbsoluteURL(this.updateMemberCommunicationInfoUrl) + '?' + this.docViewer.mapToParams(params), { observe: 'response', responseType: 'text' })
   // return this.httpClient.post(this.http.getAbsoluteURL(this.updateMemberCommunicationInfoUrl), params);
   return this.http.post(url, params);
 
  }


  // Send Token to email
  sendEmailSecurityToken(params) {
    return this.http.post(this.sendEmailSecurityTokenUrl, params);
  }

  // Verify Token sent on Email
  verifyEmailSecurityToken(params) {
    return this.http.post(this.verifyEmailSecurityTokenUrl, params)
  }

  // Send Token to Phone
  sendMobilePhoneSecurityToken(params) {
    return this.http.post(this.sendMobilePhoneSecurityTokenUrl, params)
  }
  
  // Verify Token sent to Phone
  verifyMobilePhoneSecurityToken(params) {
    return this.http.post(this.verifyMobilePhoneSecurityTokenUrl, params);
  }
  

}



// WEBPACK FOOTER //
// ./src/app/new-login/new-login.service.ts